// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + "actioncable" + "-" + "65b48d244ec21c4b72e7" + ".chunk.js"; };